<template>
	<main-tabs :links="links">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</main-tabs>
</template>

<script>
	export default {
		data() {
			return {
				links: [{
					to: {
						path: '/feeds/content/product'
					},
					label: '商品库'
				}, {
					to: {
						path: '/feeds/content/tag'
					},
					label: 'TAG'
				}]
			}
		}
	}
</script>
